import AdminRoutesHandler from "../components/RoutesHandler/AdminRoutesHandler";
import { Outlet } from "react-router-dom";

export const AdminProtected = () => {
    return (
        <AdminRoutesHandler>
            <Outlet />
        </AdminRoutesHandler>
    )
}